import { useState } from 'react'
import { Brand, BrandOnboardingStep } from '../../../../gql/types'
import { Header } from '../Header'

const steps = [
  {
    id: '01',
    name: 'MY BRAND',
    description: `Brand & Product`,
    stepOnboarding: [
      BrandOnboardingStep.setSourceChannel,
      BrandOnboardingStep.setWebsite,
      BrandOnboardingStep.setDetails,
      BrandOnboardingStep.setBusinessIndustry,
      BrandOnboardingStep.setProductDetails,
      BrandOnboardingStep.setCampaignDetails,
    ],
  },
  {
    id: '02',
    name: 'VIDEO',
    description: 'Making a creative brief',
    stepOnboarding: [
      BrandOnboardingStep.setVideoType,
      BrandOnboardingStep.setModelType,
      BrandOnboardingStep.setVoiceType,
      // BrandOnboardingStep.setPlatform,
      BrandOnboardingStep.setVideoDuration,
      BrandOnboardingStep.setVideoAspectRatio,
      BrandOnboardingStep.setRequirements,
      BrandOnboardingStep.setAddons,
      BrandOnboardingStep.setHooks,
    ],
  },
  {
    id: '03',
    name: 'Creator',
    description: `Finding a matching creator`,
    stepOnboarding: [BrandOnboardingStep.setCreatorDetails],
  },
]

interface Props {
  brand: Brand
  stepCurrent: BrandOnboardingStep
}

const Steps = ({ brand, stepCurrent }: Props) => {
  const [indexCurrent, setIndexCurrent] = useState(null)
  const [percentStepCurrent, setPercentStepCurrent] = useState('')
  const [control, setControl] = useState('')

  const onSetPercent = (stepCurrent: BrandOnboardingStep) => {
    switch (stepCurrent) {
      case BrandOnboardingStep.setSourceChannel:
        setPercentStepCurrent('10%')
        break
      case BrandOnboardingStep.setWebsite:
        setPercentStepCurrent('20%')
        break
      case BrandOnboardingStep.setDetails:
        setPercentStepCurrent('40%')
        break
      case BrandOnboardingStep.setBusinessIndustry:
        setPercentStepCurrent('50%')
        break
      case BrandOnboardingStep.setProductDetails:
        setPercentStepCurrent('75%')
        break
      case BrandOnboardingStep.setCampaignDetails:
        setPercentStepCurrent('95%')
        break
      case BrandOnboardingStep.setVideoType:
        setPercentStepCurrent('20%')
        break
      case BrandOnboardingStep.setModelType:
        setPercentStepCurrent('35%')
        break
      case BrandOnboardingStep.setVoiceType:
        setPercentStepCurrent('40%')
        break
      // case BrandOnboardingStep.setPlatform:
      //   setPercentStepCurrent('60%')
      //   break
      case BrandOnboardingStep.setVideoDuration:
        setPercentStepCurrent('50%')
        break
      case BrandOnboardingStep.setVideoAspectRatio:
        setPercentStepCurrent('60%')
        break
      case BrandOnboardingStep.setRequirements:
        setPercentStepCurrent('70%')
        break
      case BrandOnboardingStep.setAddons:
        setPercentStepCurrent('80%')
        break
      case BrandOnboardingStep.setHooks:
        setPercentStepCurrent('95%')
        break
      case BrandOnboardingStep.setCreatorDetails:
        setPercentStepCurrent('80%')
        break
      case BrandOnboardingStep.setOrderSummary:
        setPercentStepCurrent('95%')
        break
      case BrandOnboardingStep.completed:
        setPercentStepCurrent('100%')
        break
      default:
        break
    }
    setControl(stepCurrent)
  }

  return (
    <div className='px-4 pt-4'>
      <div className=''>
        <Header brand={brand} timeLeft={null} title={null} description={null} />
      </div>
      <nav aria-label='progress' className='mt-4'>
        <ol className='flex space-y-0 space-x-4 md:space-x-8'>
          {steps.map((step, stepIdx) => (
            <li key={step.id} className='flex-1'>
              <div>
                {step.stepOnboarding.includes(stepCurrent) ? (
                  <>
                    {indexCurrent === null
                      ? (() => {
                          setIndexCurrent(stepIdx)
                          return null
                        })()
                      : null}
                    {control !== stepCurrent
                      ? (() => {
                          onSetPercent(stepCurrent)
                          return null
                        })()
                      : null}
                    <div className='overflow-hidden rounded-full bg-gray-200'>
                      <div
                        className='flex flex-col h-2 rounded-full bg-gray-800'
                        aria-current='step'
                        style={{ width: percentStepCurrent }}
                      ></div>
                    </div>
                  </>
                ) : stepIdx < indexCurrent ? (
                  <>
                    <div
                      className='flex flex-col h-2 rounded-full bg-gray-800'
                      aria-current='step'
                    ></div>
                  </>
                ) : (
                  <div className='h-2 rounded-full bg-gray-200' />
                )}
              </div>
            </li>
          ))}
        </ol>
      </nav>
    </div>
  )
}

export { Steps }
